

<table class="table">
  <thead>
    <tr>
      <th>Title</th>
      <th>Snippet</th>
    </tr>
  </thead>
  <tbody>

    <tr *ngFor= "let page of releventPages" >
      <td> <a target="_black" [href]="'https://en.wikipedia.org?curid='+page.pageid">
        {{page.title}}</a></td>
      <td [innerHTML]="page.snippet"> </td>
    </tr>
  </tbody>
</table>
